import moment from "moment";
import {
  ModalBody,
  ModalHeader,
  ModalPanel,
} from "../../components/Modal";
import { SchedulePlanContainer } from "../../container/SchedulePlanContainer";
import "./styles.scss";

export const SectorAutomationScreen = ({
  selectedsUsers,
  handleCloseModal,
  modalIsOpen,
  modalFormToResolve,
  watch,
  pinnedMessages
}) => {
  const checkDate = moment().format("YYYY-MM-DD") < watch("dateToAdd")

  if (checkDate) {
    mindate = watch("dateToAdd")
  }

  return (
    <>
      {!modalFormToResolve && <ModalPanel modalIsOpen={modalIsOpen}>
        <ModalHeader title="Agendar atendimento" closeModal={handleCloseModal} />
        <ModalBody className="modal-container-sector__automation">
          <div className="modal-schedule-plan-container">
            <SchedulePlanContainer users={selectedsUsers} callback={handleCloseModal} hasMessage={pinnedMessages?.length > 0} />
          </div>
        </ModalBody>
      </ModalPanel>}
    </>
  )
}
